import { z } from 'zod';

const units = z.enum(['fraction', 'pixels', 'insetPixels']);
export const imageXYSchema = z.object({ x: z.number().finite(), y: z.number().finite(), xunits: units, yunits: units }).strict();
const position = z.tuple([z.number().finite().min(-540).max(540), z.number().finite().min(-90).max(90)]);
const common = {
  src: z.string().max(6_000_000).regex(/^data:image\/png;base64,[A-Za-z0-9+/]+={0,2}$/),
  width: z.number().int().min(1).max(4096),
  height: z.number().int().min(1).max(4096),
  opacity: z.number().min(0).max(1),
  color: z.string().regex(/^#[0-9a-f]{6}$/i),
  drawOrder: z.number().finite(),
  visible: z.boolean(),
};
export const dataImageSchema = z.discriminatedUnion('kind', [
  z.object({ ...common, kind: z.literal('ground'), corners: z.tuple([position, position, position, position]) }).strict(),
  z.object({ ...common, kind: z.literal('screen'), overlayXY: imageXYSchema, screenXY: imageXYSchema, rotationXY: imageXYSchema, size: imageXYSchema, rotation: z.number().finite() }).strict(),
  z.object({ ...common, kind: z.literal('photo') }).strict(),
 ]).refine(image => {
  if (image.kind !== 'ground') return true;
  const crosses = image.corners.map((point, index, points) => {
    const next = points[(index + 1) % 4], end = points[(index + 2) % 4];
    return (next[0] - point[0]) * (end[1] - next[1]) - (next[1] - point[1]) * (end[0] - next[0]);
  });
  return crosses.every(value => value > 0) || crosses.every(value => value < 0);
}, 'Ground images must have four convex, distinct corners.');
export type DataImage = z.infer<typeof dataImageSchema>;
